export default __webpack_public_path__ + "images/175ce8212196742ab2edd413a5f5f668.svg";